import { motion } from "framer-motion";
import {
  Video,
  Home,
  Link2,
  Megaphone,
  TrendingUp,
  Youtube,
  Mic,
  PartyPopper,
  Instagram,
} from "lucide-react";
import { SERVICES } from "../../lib/data";

const ICONS = {
  video: Video,
  home: Home,
  rings: Link2,
  megaphone: Megaphone,
  trending: TrendingUp,
  youtube: Youtube,
  mic: Mic,
  event: PartyPopper,
  instagram: Instagram,
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-16 md:py-24 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="font-body text-[11px] tracking-[0.32em] uppercase text-[#e63946]">
            Чем я занимаюсь
          </span>
          <h2 className="font-display uppercase text-5xl md:text-7xl tracking-tight text-white mt-2">
            Услуги
          </h2>
          <p className="mt-4 font-body text-sm md:text-base text-white/60 max-w-xl mx-auto leading-relaxed">
            Полный цикл производства видео и контента для бизнеса, брендов и
            личных проектов.
          </p>
        </motion.div>

        <ul className="flex flex-col divide-y divide-white/10">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Video;
            return (
              <motion.li
                key={s.id}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.04 }}
                data-testid={`service-${s.id}`}
                className="flex items-start gap-4 md:gap-6 py-5 md:py-6"
              >
                <Icon className="w-7 h-7 md:w-8 md:h-8 text-[#e63946] shrink-0 mt-0.5" aria-hidden />
                <div>
                  <h3 className="font-display uppercase text-base md:text-lg tracking-wide text-white">
                    {s.title}
                  </h3>
                  <p className="font-body text-sm md:text-base text-white/55 leading-relaxed mt-1">
                    {s.description}
                  </p>
                </div>
              </motion.li>
            );
          })}
        </ul>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="mt-10 border-l-2 border-[#e63946] bg-white/[0.02] px-5 py-4"
        >
          <p className="font-body text-sm md:text-base text-white/85 leading-relaxed">
            Помогаю компаниям и брендам создавать видео, которые не просто
            красиво выглядят, а работают на результат.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
